<template>
  <v-menu
    v-if="editMode"
    offset-y
    flat
    ref="datePickerMenu"
    v-model="isOpen"
    :data-testid="dataTestid"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :disabled="disabled"
        v-model="dateText"
        v-on="on"
        class="font-size-14"
        dense
        readonly
        hide-details
        outlined
        event-color="primary"
        :rules="rules"
        :prepend-inner-icon="icon"
        :class="inputClass"
        :data-testid="`${dataTestid}-field`"
        :label="label"
      />
    </template>
    <v-date-picker
      :disabled="disabled"
      :allowed-dates="allowedDates"
      :value="dateValue"
      class="w-100"
      no-title
      @change="onDateSelected"
    />
  </v-menu>
  <div v-else class="blue-grey--text text--darken-3 font-size-16">
    {{ dateText }}
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DatePicker',

  props: {
    dateFormat: { default: 'll', type: String, required: false },
    dataTestid: String,
    icon: String,
    label: String,
    value: String,
    inputClass: String,
    editMode: Boolean,
    required: Boolean,
    allowedDates: {
      type: Function,
      default() {
        return true
      },
    },
    disabled: Boolean,
  },

  data() {
    return { date: this.value, isOpen: false }
  },

  computed: {
    dateText() {
      const date = moment(this.value)
      if (!date.isValid()) return ''
      return date.format(this.dateFormat)
    },

    dateValue() {
      return this.value ? moment(this.value).format('YYYY-MM-DD') : null
    },

    rules() {
      return this.required
        ? [
            field =>
              Boolean(field?.length) ||
              this.$t('validation.form.this_field_is_required'),
          ]
        : []
    },
  },
  methods: {
    onDateSelected(date) {
      this.isOpen = false
      this.$emit('change', date)
    },
  },
}
</script>
